//react-components-form uuendab iga klahvivajutusega Formi konteksti, mistõttu kõik vormi väljad (ka kõik
//react-selectid) renderdatakse uuesti, kuigi muutus ainult üks väli - suurel vormil (ObjectForm) jääb sisestus
//aeglaseks. FieldConnect annab igal renderdusel uue fieldAttributes objekti (uue onBlur/onFocus funktsiooniga)
//ja uue validationErrors massiivi, seega võrreldakse neid sisu järgi; muud propid võrreldakse viite järgi.
const IGNORED_FIELD_ATTRIBUTES = ['onBlur', 'onFocus'];

const sameFieldAttributes = (prev, next) => {
    const prevAttributes = prev || {};
    const nextAttributes = next || {};
    const keys = new Set([...Object.keys(prevAttributes), ...Object.keys(nextAttributes)]);
    for (const key of keys) {
        if (!IGNORED_FIELD_ATTRIBUTES.includes(key) && prevAttributes[key] !== nextAttributes[key]) {
            return false;
        }
    }
    return true;
};

const sameValidationErrors = (prev, next) => {
    if (prev === next) {
        return true;
    }
    try {
        return JSON.stringify(prev) === JSON.stringify(next);
    } catch (e) {
        return false;
    }
};

export const shouldFieldUpdate = (prevProps, nextProps) => {
    const keys = new Set([...Object.keys(prevProps), ...Object.keys(nextProps)]);
    for (const key of keys) {
        if (prevProps[key] === nextProps[key]) {
            continue;
        }
        if (key === 'fieldAttributes' && sameFieldAttributes(prevProps[key], nextProps[key])) {
            continue;
        }
        if (key === 'validationErrors' && sameValidationErrors(prevProps[key], nextProps[key])) {
            continue;
        }
        return true;
    }
    return false;
};
